import { defineStore } from 'pinia';
import { ref } from 'vue';
import collectionsAPI from '@/api/collections';
import { useAlertStore } from '@/store/alertStore';

export const useCollectionsStore = defineStore('collections', () => {
  const collections = ref<any[]>([]);
  const collections_search = ref<any[]>([]);
  const alertStore = useAlertStore();

  const fetchCollections = async (params: any): Promise<{ data: any[]; total: number }> => {
    const response = await collectionsAPI.getCollections(params);
    const data = response.data.data;
    const total = response.data.meta?.total ?? data.length;
    collections.value = data;
    return { data, total };
  };

  const fetchCollectionById = async (id: number) => {
    const response = await collectionsAPI.getCollectionById(id);
    return response.data.data;
  };

  const createCollection = async (payload: any) => {
    const response = await collectionsAPI.createCollection(payload);
    if (!response.data.success) throw response.data;
    collections.value.push(response.data.data);
    alertStore.showAlert('Cobranza creada con éxito', 'success');
    return response.data;
  };

  const updateCollection = async (id: number, payload: any) => {
    const response = await collectionsAPI.updateCollection(id, payload);
    if (!response.data.success) throw response.data;
    const updated = response.data.data;
    const idx = collections.value.findIndex((c: any) => c.id === id);
    if (idx !== -1) collections.value[idx] = updated;
    alertStore.showAlert('Cobranza actualizada con éxito', 'success');
    return response.data;
  };

  const deleteCollection = async (id: number) => {
    await collectionsAPI.deleteCollection(id);
    collections.value = collections.value.filter((c: any) => c.id !== id);
    alertStore.showAlert('Cobranza eliminada con éxito', 'success');
  };

  const searchCollections = async (params: any) => {
    const response = await collectionsAPI.getCollections(params);
    collections_search.value = response.data.data;
    return collections_search.value;
  };

  return {
    collections,
    collections_search,
    fetchCollections,
    fetchCollectionById,
    createCollection,
    updateCollection,
    deleteCollection,
    searchCollections,
  };
});
